module.exports = __webpack_public_path__ + "475a9c8c97a82a5e4c76e5516bcc403f.png";